import { IntlTFunc } from 'next-intl';

import { ProductFragment } from '@/fo/api/magento';

import { MappedProduct, ConfigurableProduct, ProductsMindbox } from '../types';
import { configurableVariantsMapper } from '../utils';

import { utilMapSimpleProductData } from './utilMapSimpleProductData';

export const utilMapConfigurableProductData = (
  product: ProductFragment,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox,
  options?: { preselectFirstInStock?: boolean }
): MappedProduct => {
  const productData = product as ConfigurableProduct;

  const {
    sku,
    mindboxId,
    link,
    basePrice,
    finalPrice,
    labels,
    baseImage,
    thumbnail,
    mediaGallery,
    stockStatus,
    characteristics,
    brand,
    catalogBrandUrl,
    series,
    effects,
    labelsBonus,
    bonusPoints,
    bonusPointsMax,

    name,
    nameEng,
    shortDescription,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    rating,
    reviewCount,
    bestRating,
    worstRating,

    description,
    activeComponents,
    composition,
    usageInstructions,
    expert,
    currency,

    productGroup
  } = utilMapSimpleProductData(productData, t, mindboxProducts);

  const configurableVariants =
    'variants' in productData && productData.variants
      ? configurableVariantsMapper(
          productData.variants,
          t,
          mindboxProducts,
          options
        )
      : [];

  // Сохраняем оригинальные варианты для фильтрации
  const originalConfigurableVariants =
    'variants' in productData && productData.variants
      ? productData.variants
      : undefined;

  // Для нового формата HeightOption[] нет предвыбранного продукта
  const selectedProduct: MappedProduct | undefined = configurableVariants.find(
    (variant) => variant.isSelected
  )?.product;

  return {
    parentSku: selectedProduct ? sku : undefined,
    sku: selectedProduct?.sku ?? sku,
    mindboxId: selectedProduct?.mindboxId ?? mindboxId,
    link,
    name: selectedProduct?.name ?? name,
    ean: selectedProduct?.ean,
    brand,
    catalogBrandUrl,
    series,
    nameEng: selectedProduct?.nameEng ?? nameEng,
    shortDescription,
    basePrice: selectedProduct?.basePrice ?? basePrice,
    finalPrice: selectedProduct?.finalPrice ?? finalPrice,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    labels: selectedProduct?.labels ?? labels,
    labelsBonus: selectedProduct?.labelsBonus ?? labelsBonus,
    baseImage: selectedProduct?.baseImage ?? baseImage,
    thumbnail: selectedProduct?.thumbnail ?? thumbnail,
    mediaGallery: selectedProduct?.mediaGallery ?? mediaGallery,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    stockStatus: selectedProduct?.stockStatus ?? stockStatus,
    stockQuantity: selectedProduct?.stockQuantity ?? 0,
    configurableVariants,
    originalConfigurableVariants,
    effects,
    bonusPoints: bonusPoints,
    bonusPointsMax: bonusPointsMax,

    description,
    characteristics: selectedProduct?.characteristics ?? characteristics,
    activeComponents,
    composition,
    usageInstructions,
    expert,

    productGroup,
    currency
  };
};
